import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, Card } from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';
import Logo from 'src/layouts/full/shared/logo/Logo';

const SignupPageShell = ({
  title,
  description,
  maxWidth = '560px',
  fullWidth = false,
  forceDefaultLogo = false,
  children,
}) => (
  <PageContainer title={title} description={description}>
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        overflow: 'hidden',
        background: 'linear-gradient(180deg, #f6fbff 0%, #eef6ff 42%, #f8fafc 100%)',
        '&:before': {
          content: '""',
          background:
            'radial-gradient(circle at top left, rgba(111, 210, 183, 0.22), transparent 32%), radial-gradient(circle at top right, rgba(71, 136, 255, 0.18), transparent 28%), radial-gradient(circle at bottom center, rgba(251, 191, 36, 0.12), transparent 24%)',
          backgroundSize: '400% 400%',
          animation: 'gradient 15s ease infinite',
          position: 'absolute',
          height: '100%',
          width: '100%',
          opacity: '0.3',
        },
      }}
    >
      <Grid
        container
        spacing={0}
        justifyContent="center"
        sx={{
          minHeight: '100vh',
          py: fullWidth ? { xs: 2, md: 2.5 } : { xs: 3, md: 5 },
          px: fullWidth ? { xs: 1.5, md: 2.5 } : { xs: 2, md: 4 },
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          lg={fullWidth ? 12 : 5}
          xl={fullWidth ? 12 : 4}
          display="flex"
          justifyContent="center"
          alignItems={fullWidth ? 'stretch' : 'center'}
        >
          <Card
            elevation={0}
            sx={{
              p: fullWidth ? { xs: 2.5, md: 3 } : { xs: 3, md: 4 },
              zIndex: 1,
              width: '100%',
              maxWidth: fullWidth ? '100%' : maxWidth,
              borderRadius: { xs: 4, md: fullWidth ? 6 : 4 },
              border: '1px solid rgba(148, 163, 184, 0.16)',
              background: 'rgba(255,255,255,0.82)',
              backdropFilter: 'blur(18px)',
              boxShadow: fullWidth
                ? '0 26px 70px rgba(15, 23, 42, 0.10)'
                : '0 20px 48px rgba(15, 23, 42, 0.12)',
            }}
          >
            {!fullWidth && (
              <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                <Logo forceDefault={forceDefaultLogo} />
              </Box>
            )}
            {children}
          </Card>
        </Grid>
      </Grid>
    </Box>
  </PageContainer>
);

SignupPageShell.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  maxWidth: PropTypes.string,
  fullWidth: PropTypes.bool,
  forceDefaultLogo: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

SignupPageShell.defaultProps = {
  description: '',
  maxWidth: '560px',
  fullWidth: false,
  forceDefaultLogo: false,
};

export default SignupPageShell;
